export enum RecoverPasswordFormFields {
    IDENTIFIER = "identifier",
}

export type RecoverPasswordFormData = Record<RecoverPasswordFormFields, string>;
